import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'app-source-removed',
  templateUrl: './source-removed.component.html',
  styleUrls: ['../drb-diff.component.css'],
  imports: [NgIf]
})
export class SourceRemovedComponent {
  @Input() public item;

  constructor(public utility: UtilityService) {}
}
